import React from "react";
import { IUserId } from "../../User.props";
import EditUser from "./EditUser";

const EditUserIndex: React.FC<IUserId> = ({ userId }) => {
  return <EditUser userId={userId} />;
};

export default EditUserIndex;
